<ng-container *ngFor="let profil of profilCaisseFolio">
  <dsd-container
    margin="none"
    padding="md"
    border-radius="sm"
    class="info-profil-caisse-folio dsd-br-md"
    background-color="dsd-color-background-decorative-graphite-100">
    <div class="dsd-d-flex dsd-ai-baseline">
      <dsd-icon class="dsd-pr-xs" size="sm" icon-name="contenus_contour_caisses"></dsd-icon>
      <div class="dsd-m-0">
        <ng-container
          [ngTemplateOutlet]="autresCompte ? nomCaisseTitre : nomCaisse"
          [ngTemplateOutletContext]="{ $implicit: profil.descriptionCaisseCourte }"></ng-container>
        <span class="folio dsd-b-40">
          <ng-container *ngFor="let folio of profil.listeFolios; let last = last">
            {{ folio.numeroFolio }}
            <span *ngIf="!last">, </span>
          </ng-container>
        </span>
      </div>
    </div>
  </dsd-container>
</ng-container>

<ng-template #nomCaisse let-item>
  <span class="dsd-fw-bold dsd-b-30">{{ item }}</span
  ><br />
</ng-template>

<ng-template #nomCaisseTitre let-item>
  <h3 class="dsd-fw-bold dsd-b-30 dsd-m-0">{{ item }}</h3>
</ng-template>
